export default "__VITE_ASSET__C$e8kohm__"